import { render, staticRenderFns } from "./CPrefecture.vue?vue&type=template&id=05e50852&"
import script from "./CPrefecture.vue?vue&type=script&lang=js&"
export * from "./CPrefecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports